import { AQUARIST_LOGO } from '../Constants/images';
import { AQUARIST_URL } from '../Constants/links';

export const Home = () => {
  return (
    <main className="home">
      <img src={AQUARIST_LOGO} alt="Aquarist" className="home-logo" />
      <p className="home-message">Aquarist has a new home.</p>
      <a href={AQUARIST_URL} className="home-button">Visit the new site</a>
    </main>
  )
}
